module.exports = __webpack_public_path__ + "img/handIcon.670253ce.svg";